import { datadogRum } from '@datadog/browser-rum'

import { getConfig } from '@/app/config'

import { isEnabled } from '../toggles'

export const initRum = (): void => {
  if (isEnabled('datadogRum')) {
    datadogRum.init({
      applicationId: getConfig().DATADOG_RUM_APP_ID || '',
      clientToken: getConfig().DATADOG_RUM_CLIENT_TOKEN || '',
      site: getConfig().DATADOG_RUM_SITE || '',
      service: getConfig().DATADOG_RUM_SERVICE || '',
      env: window.config?.APP_ENV ?? 'local',
      version: import.meta.env.VITE_REVISION ?? 'local',
      sessionReplaySampleRate: isEnabled('datadogSessionReplay') ? 100 : 0,
      defaultPrivacyLevel: 'allow',
      trackResources: true,
      trackUserInteractions: true,
      allowedTracingUrls: [window.location.origin],
    })
  }
}

export type RumScope = {
  id: string
  email: string
  company: string
  customerId: string
}

export const { addError } = datadogRum

export const addRumScope = ({ id, email, company, customerId }: RumScope): void => {
  datadogRum.setUser({
    id,
    email,
    company,
    customerId,
  })
}

export const removeRumScope = (): void => {
  datadogRum.clearUser()
}
